import { useState, useEffect, useRef } from "react";
//import { useGetTitle } from "../../../hooks/useGetTitle";
import { useParams } from "react-router-dom";
//import { toast } from "react-toastify";

import {
  Button, Breadcrumbs, Box,
  Collapse,
  FormControl, FormControlLabel,
  InputAdornment, IconButton,
  MenuItem,
  OutlinedInput,
  Switch, Select,
  Tabs, Tab, Typography, Table, TableHead, TableRow, TableCell, TableBody, TextField,
  useTheme,
} from "@mui/material";

import styled from "styled-components";

import SearchIcon from "@mui/icons-material/Search"; // MUI의 검색 아이콘
import DescriptionIcon from "@mui/icons-material/Description"; // MUI 문서 아이콘
import CloseIcon from '@mui/icons-material/Close';
import CheckIcon from '@mui/icons-material/Check';

import dayjs from "dayjs";

import { 
  useGetTableData, useGetTableDataInQueryString,
  useCreateTableData, 
  usePutTableData, 
  useDeleteTableData 
} from "../../../components/Table/hooks";

import { 
  assessmentLevelColumns, assessmentLevelColumns_admin,
  frequencyLevelRoleMapper, 
  importancyLevelRoleMapper, 
  strategyResultStatusColumns 
} from "../../../constants/columns";
import { NewTableTemplate, } from "../../../components/Table/TableTemplate";
import { ModalTemplate } from "../../../components/Table/ModalTemplate";
import Buttons from "../../../../common/Buttons";
import { 
  BreadcrumbsTable,
  ConfirmDialog, ConfirmDialogSingle, 
  deepCopy,
  SnackbarAlert, 
  formatDateWithDayjs, formatDateToDayjs, getTodayByDayjs,
} from "../../../components/common/HelperFunc";
import * as message from "../../../constants/messages";
import { FONT_PROPS, COLORS } from "../../../styles/colors";

///////////////////////////////
// 스타일
///////////////////////////////

// 테이블 컨테이너 스타일
const TableContainer = styled.div`
  width: 100%;
  height: 100%;
  padding: 16px 32px 16px 32px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;

//////////////////////////////////
// 위험성 수준 평가 컴포넌트
//////////////////////////////////
const PARENT_TITLE = "평가관리";
const CHILD_TITLE = "위험성 수준 평가";
export function AssessmentLevel() {
  const theme = useTheme();
  // const { group_code, project_code } = useParams();

  ////////////////////////
  // 렌더링
  ////////////////////////

  // 탭 상태관리
  const [tabValue, setTabValue] = useState('one');
  const handleTabChange = (event, newValue) => setTabValue(newValue);
  function renderData() {
    return (
      <>
        {/* 탭 기능 */}
        <Box sx={{ display: 'flex', borderBottom: `1px solid ${theme.palette.divider}`, }} >
          <Tabs
            value={tabValue}
            onChange={handleTabChange}
            aria-label="basic tabs example"
            sx={{
              borderBottom: 'none',
              marginLeft: '32px',
              '& .MuiTabs-indicator': {
                backgroundColor: theme.palette.primary.main,
              },
            }}
          >
          <Tab value="one" label="위험성 수준 평가" 
            sx={{
              borderLeft: `1px solid ${theme.palette.divider}`,
              borderRight: `1px solid ${theme.palette.divider}`,
              borderTop: `1px solid ${theme.palette.divider}`,
              borderTopLeftRadius: '0.375rem',
              borderTopRightRadius: '0.375rem',
              marginRight: '0.3rem',
              bgcolor: tabValue === 'one' 
                ? 'rgb(var(--mui-palette-primary-mainChannel) / 0.16)' 
                : 'var(--mui-palette-background-paper)',
              fontFamily: FONT_PROPS.PRIMARY,
              fontWeight: FONT_PROPS.MEDIUM,
              fontSize: '16px',
            }}
          />
          <Tab value="two" label="개선 대책 조회"
            sx={{
                borderLeft: `1px solid ${theme.palette.divider}`,
                borderRight: `1px solid ${theme.palette.divider}`,
                borderTop: `1px solid ${theme.palette.divider}`,
                borderTopLeftRadius: '0.375rem',
                borderTopRightRadius: '0.375rem',
                marginRight: '0.3rem',
                bgcolor: tabValue === 'two' 
                  ? 'rgb(var(--mui-palette-primary-mainChannel) / 0.16)' 
                  : 'var(--mui-palette-background-paper)',
                fontFamily: FONT_PROPS.PRIMARY,
                fontWeight: FONT_PROPS.MEDIUM,
                fontSize: '16px',
            }}
          />
          </Tabs>
        </Box>
        
        {/* 위험성 수준 평가 */}
        {tabValue === 'one' && <RiskEvaluation /> }
        {/* 개선 대책 조회 */}
        {tabValue === 'two' &&  <StrategyResultStatus />}
      </>
    );
  }

  // AssessmentLevel 렌더링
  return (
    <Box sx={{ bgcolor: 'var(--mui-palette-background-paper)',height: '100%',display: 'flex',flexDirection: 'column'}}>
      {/* 브레드크럼 + 타이틀 */}
      <BreadcrumbsTable parentTitle={PARENT_TITLE} childTitle={CHILD_TITLE} useTab={true} />
      {/* 테이블 표시 */}
      {renderData()}
    </Box>
  );
}

// 위험성 수준 평가
const RiskEvaluation = () =>{
  const { group_code, project_code } = useParams();
  const theme = useTheme();

  ////////////////////////
  // CRUD 요청
  ////////////////////////

  // 위험성 수준 판단 기준 가능성(빈도) 데이터 조회 요청
  const getFrequencyData = useGetTableData(
    "request",
    "/getSafeCalFrequency",
    group_code,
    project_code
  );
  // 위험성 수준 판단 기준 중대성(강도) 데이터 조회 요청
  const getImportancyData = useGetTableData(
    "request",
    "/getSafeCalImportancy",
    group_code,
    project_code
  );
  // 위험성 허용 기준 데이터 조회 요청
  const getStandardData = useGetTableData(
    "request",
    "/getSafeCalStandard",
    group_code,
    project_code
  );

  // 데이터 조회 요청
  const getData = useGetTableData(
    "request",
    "/getRiskAssessment",
    group_code,
    project_code
  );
  // 데이터 생성 요청
  const postData = useCreateTableData( 
    "request",
    "/postRiskAssessment",
    group_code,
    project_code
  );
  // 데이터 수정 요청
  const putData = usePutTableData(
    "request",
    "/putRiskAssessment",
    group_code,
    project_code
  );
  // 데이터 삭제 요청
  const deleteData = useDeleteTableData(
    "request",
    "/deleteRiskAssessment",
    group_code,
    project_code
  );

  // 데이터 업데이트 알람 상태 관리
  const [dataAlert, setDataAlert] = useState({
    isOpen: false,
    message: '',
    severity:'' // 'success' | 'error' | 'warning' | 'info'
  });
  const openDataAlert = (message, severity = 'success') => {
    setDataAlert({
      ...dataAlert,
      isOpen: true,
      message: message,
      severity: severity
    });
  };
  const closeDataAlert = () => {
    setDataAlert({
      ...dataAlert,
      isOpen: false,
      message: '',
      severity: '',
    });
  };

  // 메시지 박스의 알람 메시지
  const [messageAlarm, setMessageAlarm] = useState({
      isOpen: false,
      title: '',
      message: '',
  });
  const openMessageAlarm = (title='', message='',) => {
    setMessageAlarm({
      ...messageAlarm,
      isOpen: true,
      title: title,
      message: message,
    });
  };
  const closeMessageAlarm = () => {
    setMessageAlarm({
      ...messageAlarm,
      isOpen: false,
      title: '',
      message: '',
    });
  };

  // 임시 데이터 상태 관리
  const [tempData, setTempData] = useState([]);
  const handleSetTempData = (data) => setTempData(data);
  useEffect(() => {
    const tempData = deepCopy(getData.data);
    for(let i = 0; i < tempData.length; ++i) {
      // 인덱스 추가(행 편집 용도로 사용)
      tempData[i].__index = i;
      // 평가일자 포맷 변환(관리자모드 시 편집 용도로 사용)
      tempData[i].__eval_date = formatDateToDayjs(tempData[i].eval_date);
    }
    handleSetTempData(tempData);
  },[getData.data]);

  // 위험성 수준 판단 기준 모달 상태 관리
  const [evaluationGuidelines, setEvaluationGuidelines] = useState({ isOpen: false });
  const openEvaluationGuidelines = () => setEvaluationGuidelines({ isOpen: true });
  const closeEvaluationGuidelines = () => setEvaluationGuidelines({ isOpen: false });

  // 테이블 참조
  const tableRef = useRef();
  const clearSelection = () => { tableRef.current?.clearSelection(); };
  const getSelectedRows = () => { return tableRef.current?.getSelectedRows(); };

  // 테이블의 상단 툴바 커스터마이징 관련 내용
  const [showSearch, setShowSearch] = useState(false); // 검색창 열림 여부
  const [globalFilter, setGlobalFilter] = useState(''); // 검색 텍스트 상태
  const [showAdminMode, setShowAdminMode] = useState(false); // 관리자 모드 활성화 여부
  const customTableTopToolbar = (table) => (
    <Box width="100%" display="flex" justifyContent="space-between" alignItems="center" p={2}>
      {/* 왼쪽 영역 */}
      <Box display={"flex"} alignItems="center" gap={4} marginLeft={'16px'}>
        {/* 위험성 수준 판단 기준 가이드 버튼 */}
        <Button
          variant="outlined"
          startIcon={<DescriptionIcon />}
          onClick={() => {
            //console.log("감소대책 수립 가이드 클릭!!");
            openEvaluationGuidelines();
          }}
          sx={{ fontFamily: FONT_PROPS.PRIMARY,fontWeight: FONT_PROPS.MEDIUM,fontSize: '15px',padding: "8px 16px 8px 16px",marginRight: "8px",}}>
          위험성 수준 판단 기준
        </Button>
      </Box>

      {/* 오른쪽 영역 - 기존 내부 액션도 원하면 여기에 직접 렌더링 */}
      <Box display="flex" alignItems="center" gap={2}>
        {/* 검색창 */}
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <IconButton onClick={() => setShowSearch((prev) => !prev)}>
            <SearchIcon />
          </IconButton>
        
          <Collapse in={showSearch} orientation="horizontal">
            <TextField
            size="small"
              placeholder="검색"
              value={globalFilter}
              onChange={(e) => {
                setGlobalFilter(e.target.value);
                table.setGlobalFilter(e.target.value);
              }}
              sx={{ minWidth: 200 }}
              variant="outlined"
              slots={{ input: OutlinedInput,}}
              slotProps={{
                input: {
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        onClick={() => {
                          setGlobalFilter('');
                          table.setGlobalFilter('');
                          setShowSearch(false); // 닫기
                        }}
                      >
                        <CloseIcon fontSize="small" />
                      </IconButton>
                    </InputAdornment>
                  ),
                }
              }}
            />
          </Collapse>
        </Box>
        {/* 삭제버튼 */}
        {showAdminMode && 
          <Buttons.Delete 
            onClick={openDeleteModal} // 행 삭제 로직 실행
            disabled={table.getSelectedRowModel().rows.length === 0}
            sx={{ padding: '12px 16px',}}
          >
            데이터 삭제
          </Buttons.Delete>
        }
        {/* 관리자 모드 */}
        <FormControl component="fieldset">
          <FormControlLabel
            value="top"
            control={
              <Switch color="primary" 
                checked={showAdminMode}
                onChange={(event) => {
                  setShowAdminMode(event.target.checked);
                  clearSelection();
                }}
              />
            }
            label="관리자모드"
            labelPlacement="end" // bottom,end,start,top
            sx={{marginLeft : '4px'}}
          />
        </FormControl>
      </Box>
    </Box>
  );

  // 행 편집 작업 (가능성빈도, 중대성강도)
  const changeRowData = ({ values, row, table }) => {
    //console.log("✅ 편집 호출 완료!", values);
    //console.log("✅ 편집 호출 완료!", row.original);

    // 편집된 데이터 변경
    const findData = tempData.find(item => {
      return item.__index === row.original.__index;
    });
    Object.keys(values).forEach((key) => {
      if (findData[key] !== values[key]) {
        findData[key] = values[key];
      }
    });

    // 데이터 변환
    const frequencyId = getFrequencyId(findData.frequency_level);
    if(frequencyId) {
      findData.frequency_id = frequencyId;
    }
    const importancyId = getImportancyId(findData.importancy_level);
    if(importancyId) {
      findData.importancy_id = importancyId;
    }
    const calculateLevel = calculateRiskLevel(findData.frequency_level, findData.importancy_level);
    const standardId = getStandardId(calculateLevel);
    if(standardId) {
      findData.standard_id = standardId;
    }

    // TempData 변경
    const data = tempData.map(item => {
      return item.__index === row.original.__index ? findData : item;
    });
    handleSetTempData(data);
  };
  // 위험성 수준 평가 테이블의 전체 행 데이터 편집 완료 액션
  const completeEditAllConfirm = !showAdminMode ? (
    <Buttons.Custom
      startIcon={<CheckIcon />}
      onClick={(event) =>{
        event.stopPropagation(); // 이벤트 전파 중단
        //
        const findDatas = tempData.filter((item) => {
          // 1. frequency_level과 importancy_level 속성이 있는지 확인
          // 2. eval_status가 없거나, 있더라도 승인완료 전인지 확인
          const hasLevels = item.hasOwnProperty('frequency_level') && item.hasOwnProperty('importancy_level');
          const isNotApproved = !item.eval_status || item.eval_status < 20; // 20: 승인완료
          return hasLevels && isNotApproved;
        });
          
        if(findDatas.length <= 0) {
          openMessageAlarm(
            '안내',
            '전체 저장할 항목이 없습니다.'
          );
          return;
        }
        updateEditData(findDatas);
      }}
      sx={{ padding: '8px 12px' }}
    >
      전체 저장
    </Buttons.Custom>
  ) : (
    <Buttons.Custom
      startIcon={<CheckIcon />}
      onClick={(event) =>{
        event.stopPropagation(); // 이벤트 전파 중단
        const findDatas = tempData.filter((item) => {
          // 평가대기는 수정 불가
          const isWating = item?.eval_status ? true : false;
          // 평가일자가 유효한지 확인
          const isValidDate = dayjs(item.__eval_date).isValid();
          return isWating && isValidDate;
        });
          
        if(findDatas.length <= 0) {
          openMessageAlarm(
            '안내',
            '전체 수정할 항목이 없습니다.'
          );
          return;
        }
        updateEditDataByAdmin(findDatas);
      }}
      sx={{ padding: '8px 12px' }}
    >
      전체 수정
    </Buttons.Custom>
  );
  // 위험성 수준 평가 테이블의 개별 행 데이터 편집 완료 액션
  const completeEditConfirm = (rowData) => {
    let isDisabled = rowData.eval_status >= 20; // 20: 승인완료
    if(showAdminMode) isDisabled = false;
    return(
      <>
        {!showAdminMode ? (
          <Buttons.Custom
            //startIcon={<CheckIcon />}
            disabled={isDisabled}
            onClick={(event) =>{
              event.stopPropagation(); // 이벤트 전파 중단
              if(checkData(rowData)) {
                openMessageAlarm(
                  '안내',
                  '가능성(빈도) 및 중대성(강도)을 설정해주세요.'
                );
                return;
              }
              updateEditData(rowData);
            }}
            // sx={{ padding: '8px 12px' }}
          >
            저장
          </Buttons.Custom> 
        ) : (
          <Buttons.Custom
            disabled={!rowData?.eval_status} // 평가 대기는 수정 불가
            onClick={(event) =>{
              event.stopPropagation(); // 이벤트 전파 중단
              if(checkDataByAdmin(rowData)) {
                openMessageAlarm(
                  '안내',
                  '평가일자를 설정해주세요.'
                );
                return;
              }
              updateEditDataByAdmin(rowData);
            }}
          >
            수정
          </Buttons.Custom>
        )}
      </>
    );
  };
  // DB 업데이트 (수정 데이터)
  const updateEditData = async (rowDatas) => {
    try {
      // 배열이 아닌 경우 배열로 변환
      const tempRowDatas = Array.isArray(rowDatas)? rowDatas: [rowDatas]; 

      // 데이터 가공 - 신규 / 기존 분리
      const newData=[]; 
      const prevData=[];
      tempRowDatas.forEach((item) => {
        if(!item.eval_id) {
          newData.push(item);
        }
        else {
          prevData.push(item);
        }
      });
      
      // 신규
      if(newData.length > 0) {
        const addData = [];
        for(const item of newData){
          const data ={
            register_cause_id: item.register_cause_id,
            frequency_id: item.frequency_id,
            importancy_id: item.importancy_id,
            standard_id: item.standard_id,
            eval_status: 10, // 평가 상태: 10(평가완료)
            eval_date: getTodayByDayjs(),
          };
          addData.push(data);
        }
        // 데이터베이스 업데이트
        await postData.mutateAsync(addData);
      }
      // 기존
      if(prevData.length > 0) {
        const updateData =[];
        for(const item of prevData) {
          const data ={
            eval_id: item.eval_id,
            register_cause_id: item.register_cause_id,
            frequency_id: item.frequency_id,
            importancy_id: item.importancy_id,
            standard_id: item.standard_id,
            eval_status: 10, // 평가 상태: 10(평가완료)
            eval_date: getTodayByDayjs(), 
          };
          updateData.push(data);
        }
        // 데이터베이스 업데이트
        await putData.mutateAsync({ updateData });
      }
      
      openDataAlert(message.addSuccess);
    }
    catch (error) {
      console.error("데이터 수정 중 오류 발생:", error);
    }
  }
  // DB 업데이트 (수정 데이터) - 관리자 모드
  const updateEditDataByAdmin = async (rowDatas) => {
    try {
      // 배열이 아닌 경우 배열로 변환
      const tempRowDatas = Array.isArray(rowDatas)? rowDatas: [rowDatas]; 
      const updateData =[];
      for(const item of tempRowDatas) {
        // 평가일자가 변경되었는지 확인 후 반영
        const __evalDate = formatDateWithDayjs(item.__eval_date);
        const evalDate = formatDateWithDayjs(item.eval_date); 
        const isSame = dayjs(__evalDate).isSame(dayjs(evalDate), 'day')

        let udpateDate = evalDate;
        if(!isSame) { udpateDate = __evalDate; } // 평가일자가 변경되었을 때만 수정일자 반영

        const data ={
          eval_id: item.eval_id,
          frequency_id: item.frequency_id,
          importancy_id: item.importancy_id,
          standard_id: item.standard_id,
          eval_status: 10, // 평가 상태: 10(평가완료)
          eval_date: isSame ? evalDate : __evalDate,
          approve_date: null, // 승인일자 초기화
          update_date: udpateDate,
        };
        updateData.push(data);
      }
      // 데이터베이스 업데이트
      await putData.mutateAsync({ updateData });
      
      openDataAlert(message.updateEditSuccess);
    }
    catch (error) {
      console.error("데이터 수정 중 오류 발생:", error);
    }
  }

  // 위험성 수준 평가 삭제 모달 상태 관리
  const [deleteModal, setDeleteModal] = useState({ isOpen: false });
  const openDeleteModal = () => setDeleteModal({ isOpen: true });
  const closeDeleteModal = () => setDeleteModal({ isOpen: false });

  // DB 업데이트 (삭제 데이터)
  const deleteEditData = async () => {
    closeDeleteModal();
    //console.log('✅ 확인 눌림 → 다음 동작 실행');
    try {

      // 선택된 행(row) 가져오기
      const selectedRows = getSelectedRows().map((row) => row.original);
      const filteredRows = selectedRows.filter((row) => row.eval_id);
      // 선택된 행(row)의 id 가져오기
      const selectedIds = filteredRows.map((row) => row.eval_id);

      if(selectedIds.length <= 0) {
        openMessageAlarm(
          '안내',
          `평가 상태가 '평가완료' 또는 '승인완료'인 데이터만 삭제할 수 있습니다.`
        );
        return;
      }

      // 데이터베이스 업데이트
      const result = await deleteData.mutateAsync({
        deleteParam: 'eval_id',
        param: selectedIds,
      });

      if(result.status === 200) {
        openDataAlert(message.deleteSuccess);
      }

      // 선택 상태 초기화
      clearSelection();
    }
    catch (error) {
      console.error("데이터 삭제 중 오류 발생:", error);
    }
  };

  ////////////////////////
  // Helper Functions
  ////////////////////////

  // 데이터 빈칸 체크
  const checkData = (data) => {
    const tempData = Array.isArray(data)? [...data]: [...[data]]; // 배열이 아닌 경우 배열로 변환 후 복제

    // 데이터가 없을 때
    if(tempData.length === 0) { 
      return true;
    }

    // 데이터가 있을 때
    const hasValidData = tempData.some(
      item => !item.frequency_level || !item.importancy_level
    );
    return hasValidData;
  };
  // 데이터 빈칸 체크 - 관리자 모드
  const checkDataByAdmin = (data) => {
    const tempData = Array.isArray(data)? [...data]: [...[data]]; // 배열이 아닌 경우 배열로 변환 후 복제

    // 데이터가 없을 때
    if(tempData.length === 0) { 
      return true;
    }

    // 데이터가 있을 때
    for(const item of tempData) {
      const d = dayjs(item.__eval_date).isValid(); // 날짜 형식이 맞지 않으면 NaN 반환
      if(!d) {
        return true;
      }
    }
    return false;
  };

  // 가능성(빈도) 레벨에 따른 ID 반환
  const getFrequencyId = (freqLevel) => {
    if(!freqLevel) {
      return null;
    }
          
    const data = getFrequencyData.data.find( item => {
      return freqLevel === item.frequency_level;
    });
    return data.frequency_id;
  }

  // 중대성(강도) 레벨에 따른 ID 반환
  const getImportancyId = (impLevel) => {
    if(!impLevel) {
      return null;
    }

    const data = getImportancyData.data.find( item => {
      return impLevel === item.importancy_level;
    });
    return data.importancy_id;
  }

  // 위험도 계산 함수
  const calculateRiskLevel = (freqLevel, impLevel) => {
    if(!freqLevel || !impLevel) {
      // null or undefined
      return 0;
    }

    const riskValue = freqLevel * impLevel;
    return riskValue;
  };

  // 위험성 허용 기준 ID 반환
  const getStandardId = (riskLevel) => {
    if(riskLevel <= 0) {
      return null;
    } 

    const data = getStandardData.data.find( item => {
      return riskLevel <= item.risk_level_max;
    });
    return data.standard_id;
  };

  return(
    <TableContainer>
      {/* 현재 월 타이틀 */}
      <Box sx={{ paddingBottom: '12px', fontSize: 16, fontWeight: FONT_PROPS.fontWeight, }} >
        [ {dayjs().month() + 1}월 위험성 수준 평가 ]
      </Box>
      {/** 위험성 수준 평가 테이블 표시 */}
      <NewTableTemplate 
        ref={tableRef}
        columns={showAdminMode ? assessmentLevelColumns_admin : assessmentLevelColumns}
        data={tempData || []}
        topToolbarContent={customTableTopToolbar}
        renderRowActionHeader={completeEditAllConfirm}
        renderRowActionContent={completeEditConfirm}
        renderRowActionCustomOptions={changeRowData}
        editDisplayMode={"row"}
        enableCustomGlobalFilter={true}
        enabledSelectionRow={showAdminMode}
        enabledSelectionAllRow={showAdminMode}
        templateSX ={{
          border: `1px solid ${theme.palette.divider}`,
          borderRadius: "0.375rem", 
          boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.05)',
        }}
      />
      {/** 위험성 수준 판단 기준 모달 */}
      <ModalTemplate
        isOpen={evaluationGuidelines.isOpen}
        handleConfirm={closeEvaluationGuidelines}
        handleCancel={closeEvaluationGuidelines}
        title="위험성 수준 판단 기준"
        confirmText="확인"
        enableSingleActionButton={true}
        containerSX={{ width: 'auto', height: 'auto' }}
      >
        <StandardRiskLevel />
      </ModalTemplate>
      {/* 삭제 메시지 */}
      <ConfirmDialog  
        open={deleteModal.isOpen}
        title="정말 삭제하시겠어요?"
        message="삭제하면 복구할 수 없습니다."
        onConfirm={deleteEditData}
        onCancel={closeDeleteModal}
      />
      {/* 데이터 알람 */}
      <SnackbarAlert 
        open={dataAlert.isOpen}
        onClose={closeDataAlert}
        message={dataAlert.message}
        severity={dataAlert.severity} // 'success' | 'error' | 'warning' | 'info'
        //anchorOrigin = {{vertical: "top", horizontal: "center"}}
      />
      {/* 기타 메시지 박스 알람 */}
      <ConfirmDialogSingle  
        open={messageAlarm.isOpen}
        title={messageAlarm.title}
        message={messageAlarm.message}
        onCancel={closeMessageAlarm}
      />
    </TableContainer>
  );
}   

// 위험성 수준 판단 기준
const StandardRiskLevel = () => {
  const { group_code, project_code } = useParams();
  const theme = useTheme();

  ////////////////////////
  // CRUD 요청
  ////////////////////////

  // 위험성 수준 판단 기준 가능성(빈도) 데이터 조회 요청
  const getFrequencyData = useGetTableData(
    "request",
    "/getSafeCalFrequency",
    group_code,
    project_code
  );
  // 위험성 수준 판단 기준 중대성(강도) 데이터 조회 요청
  const getImportancyData = useGetTableData(
    "request",
    "/getSafeCalImportancy",
    group_code,
    project_code
  );

  return (
    <Box sx={{ px: 4, py: 1, display: 'flex', justifyContent: 'center', gap: 4, }}>
      <Box>
        {/* 가능성 판단 기준 */}
        <Table sx={{ border: "2px solid #e5e5e5" }} size="small">
          <TableHead>
            <TableRow
              sx={{
                fontWeight: FONT_PROPS.MEDIUM,
                padding: "8px 16px",
                "& td": {
                  borderRight: "1px solid #e5e5e5",
                },
                "& td:last-child": {
                  borderRight: "none",
                },
              }}
            >
              <TableCell
                colSpan={2}
                align="center"
                sx={{ background: "#DBEAFE",fontSize: "1rem",padding: "8px 16px",}}>
                가능성(빈도)
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {Object.entries(frequencyLevelRoleMapper).reverse()?.map(([level, text]) => (
              <TableRow
                key={level}
                sx={{
                  fontSize: "1rem",
                  padding: "8px 16px",
                  "& td": {
                    borderRight: "1px solid #e5e5e5",
                  },
                  "& td:last-child": {
                    borderRight: "none",
                  },
                }}
              >
                <TableCell align="center" sx={{ whiteSpace: "nowrap", padding: "8px 16px" }}>
                  {text}({level})
                </TableCell>
                <TableCell align="center" sx={{ padding: "8px 16px" }}>
                {getFrequencyData.data?.find(
                  (f) => f.frequency_level === Number(level)
                  ).frequency_description
                }
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Box>
      <Box>
        {/* 중대성 판단 기준 */}
        <Table sx={{ border: "2px solid #e5e5e5" }} size="small">
          <TableHead>
            <TableRow
                sx={{
                fontWeight: "500",
                padding: "8px 16px",
                "& td": {
                    borderRight: "1px solid #e5e5e5",
                },
                "& td:last-child": {
                    borderRight: "none",
                },
                }}
            >
              <TableCell
              colSpan={2}
              align="center"
                sx={{
                  background: "#DBEAFE",
                  fontSize: "1rem",
                  padding: "8px 16px",
                }}
              >
                중대성(강도)
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {Object.entries(importancyLevelRoleMapper).reverse()?.map(([level, text]) => (
              <TableRow
                  sx={{
                  fontSize: "1rem",
                  padding: "8px 16px",
                  "& td": {
                      borderRight: "1px solid #e5e5e5",
                  },
                  "& td:last-child": {
                      borderRight: "none",
                  },
                  }}
                  key={level}
                >
                  <TableCell align="center" sx={{ whiteSpace: "nowrap", padding: "8px 16px" }}>
                    {text}({level})
                  </TableCell>
                  <TableCell align="center" sx={{ padding: "8px 16px" }}>
                  {getImportancyData.data?.find(
                      (i) => i.importancy_level === Number(level)
                      ).importancy_description
                  }
                  </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Box>
    </Box>
  );
}

// 개선 대책 조회
function StrategyResultStatus() {
  const { group_code, project_code } = useParams();
  const theme = useTheme();

  ////////////////////////
  // CRUD 요청
  ////////////////////////

  // 유해위험요인등록 현황 조회 요청
  const getRegisterStatusData = useGetTableData(
    "request",
    "/getRegisterStatus", 
    group_code,
    project_code
  );

  // 필터링 목록 조회 요청 (평가년도별, 평가년도의 최신 평가 월을 가져옵니다.)
  const getFilterListData = useGetTableData(
    "request",
    "/getStrategyResultFilterList",
    group_code,
    project_code,
  );

  // 데이터 조회에 필요한 조건을 상태로 관리합니다. (평가연도, 평가월, 설비명)
  const [searchStatus, setSearchStatus] = useState({});
  // 데이터 조회에 필요한 쿼리스트링을 만듭니다.
  const qeuryString = { 
    params: { // 쿼리스트링 만들때 params를 사용하는게 규칙입니다.
      year: searchStatus.year,
      month: searchStatus.month,
      machine_id: searchStatus.machine_id,
    },
  }
  // 데이터 조회 요청
  const getData = useGetTableDataInQueryString(
    "request",
    "/getStrategyResultStatus",
    group_code,
    project_code,
    qeuryString,
  );

  // 최신 평가연도, 최신월, 설비 카테고리 상태를 초기화합니다.
  useEffect(() => {
    // 데이터가 로드되지 않았거나 비어 있는 경우 처리 중단
    if(!getFilterListData.data || getFilterListData.data.length === 0 ) {
      return;
    }
    if(!getRegisterStatusData.data || getRegisterStatusData.data.length === 0) {
      return;
    }
      
    // 최신 평가연도 데이터 가져오기
    let latestYearData = null;
    for(let i = getFilterListData.data.length - 1; i >= 0; i--) {
      if(getFilterListData.data[i].create_year &&
        getFilterListData.data[i].latest_month) {
        latestYearData = getFilterListData.data[i];
        break;
      }
    }
    if(!latestYearData) {
      return; // 최신 평가연도 데이터가 없으면 처리 중단
    }

    const data = 
    {
      year: latestYearData.create_year,
      month: Number(latestYearData.latest_month),
      machine_id: 'all', // 모든 설비를 조회하기 위해 'all'로 설정합니다.
    };
    
    setSearchStatus(data);
  }, [getFilterListData.data, getRegisterStatusData.data]);

  // 데이터가 변경되었을 때 임시 데이터 저장
  // 임시 데이터를 가지는 이유는 저장전까지 테이블의 데이터를 변경(개선 완료일, 개선전 사진, 개선후 사진)을 하기 위함
  const [tempData, setTempData] = useState([]);
  const handleSetTempData = (data) => setTempData(data);
  // 데이터 조회 시, 데이터가 변경될 때마다 임시 데이터를 갱신합니다.
  useEffect(() => {
    const tempData = [...getData.data];
    for(let i = 0; i < tempData.length; ++i) {
      // 개선 전,후 사진 확대 상태 변수
      tempData[i].imageStatus = 'none'; 
    }
    handleSetTempData(tempData);
  },[getData.data]);

  // 개선전,후 사진 모달 상태 관리
  // 렌더 상태값: 
  // none(기본값), expand_before_image(개선전 사진 확대), expand_after_image(개선후 사진 확대)
  const [showImproveImage, setShowImproveImage] = useState({
    isOpen: false,
    state: 'none',
    rowData: null,
  });
  const openShowImproveImage = (state, rowData) => {
    setShowImproveImage({
      ...showImproveImage,
      isOpen: true,
      state: state,
      rowData: rowData,
    });
  };
  const closeShowImproveImage = () => {
    setShowImproveImage({
      ...showImproveImage,
      isOpen: false,
      state: 'none',
      rowData: null,
    });
  };

  // 평가연도 목록 (중복 제거를 위한 작업)
  const yearList = Array.from(
    new Set(getFilterListData.data.map(item => item.create_year))
  );
  // 설비명 목록 (중복 제거를 위한 작업)
  const machineIdList = Array.from(
    new Map(
      getRegisterStatusData.data.map((item) => [
        item.machine_id, 
        { 
          machine_id: item.machine_id, 
          machine_name: item.machine_name 
        }
      ])
    ).values()
  );
  machineIdList.unshift({ machine_id: 'all', machine_name: '전체' }); // 전체 추가
  //console.log(machineIdList);

  // 테이블 참조
  // const tableRef = useRef();
  // const clearSelection = () => { tableRef.current?.clearSelection(); };
  // const getSelectedRows = () => { return tableRef.current?.getSelectedRows(); };

  // 테이블의 상단 툴바 커스터마이징 관련 내용
  const [showSearch, setShowSearch] = useState(false); // 검색창 열림 여부
  const [globalFilter, setGlobalFilter] = useState(''); // 검색 텍스트 상태
  const customTableTopToolbar = (table) => (
    <Box width="100%" display="flex" justifyContent="space-between" alignItems="center" p={2}>
      {/* 왼쪽 영역 */}
      <Box display={"flex"} alignItems="center" gap={4} marginLeft={'16px'}>
          {/* 평가연도 카테고리 */}
          <FormControl size="small">
              <Box
                  sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: "16px",
                  }}
              >
                  <Typography
                      sx={{
                          fontWeight: FONT_PROPS.SEMIBOLD,
                          fontSize: 15,
                          color: theme.text,
                      }}
                  >
                      평가연도
                  </Typography>
                  <Select
                      value={searchStatus.year || ""}
                      displayEmpty
                      onChange={(e) => {
                          setSearchStatus({
                              ...searchStatus,
                              year: e.target.value,
                          });
                      }}
                      sx={{
                          width: "100px",
                          fontWeight: FONT_PROPS.SEMIBOLD,
                          color: theme.text,
                          fontSize: 15,
                      }}
                  >
                      {/* 필터 목록 */}
                      {yearList.reverse().map((year, index) => (
                          <MenuItem
                              key={index}
                              value={year}
                              sx={{
                                  fontWeight: FONT_PROPS.SEMIBOLD,
                                  color: theme.text,
                                  fontSize: 15,
                              }}
                          >
                              {year}년
                          </MenuItem>
                      ))}
                  </Select>
              </Box>
          </FormControl>
          {/* 평가월 카테고리 */}
          <FormControl size="small">
              <Box
                  sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: "16px",
                  }}
              >
                  <Typography
                      sx={{
                          fontWeight: FONT_PROPS.SEMIBOLD,
                          fontSize: 15,
                          color: theme.text,
                      }}
                  >
                      평가월
                  </Typography>
                  <Select
                      value={searchStatus.month || ""}
                      displayEmpty
                      onChange={(e) => {
                          setSearchStatus({
                              ...searchStatus,
                              month: e.target.value,
                          });
                      }}
                      sx={{
                          width: "80px",
                          fontWeight: FONT_PROPS.SEMIBOLD,
                          color: theme.text,
                          fontSize: 15,
                      }}
                  >
                      {/* 필터 목록 */}
                      {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].reverse().map((month, index) => (
                          <MenuItem
                              key={index}
                              value={month}
                              sx={{
                                  fontWeight: FONT_PROPS.SEMIBOLD,
                                  color: theme.text,
                                  fontSize: 15,
                              }}
                          >
                              {month}월
                          </MenuItem>
                      ))}
                  </Select>
              </Box>
          </FormControl>
          {/* 설비명 카테고리 */}
          <FormControl size="small">
              <Box
                  sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: "16px",
                  }}
              >
                  <Typography
                      sx={{
                          fontWeight: FONT_PROPS.SEMIBOLD,
                          fontSize: 15,
                          color: theme.text,
                      }}
                  >
                      설비명
                  </Typography>
                  <Select
                      value={searchStatus.machine_id || ""}
                      displayEmpty
                      onChange={(e) => {
                          setSearchStatus({
                              ...searchStatus,
                              machine_id: e.target.value,
                          });
                      }}
                      sx={{
                          minWidth: "120px",
                          fontWeight: FONT_PROPS.SEMIBOLD,
                          color: theme.text,
                          fontSize: 15,
                      }}
                  >
                      {/* 필터 목록 */}
                      {machineIdList.map((data, index) => (
                          <MenuItem
                              key={index}
                              value={data.machine_id}
                              sx={{
                                  fontWeight: FONT_PROPS.SEMIBOLD,
                                  color: theme.text,
                                  fontSize: 15,
                              }}
                          >
                              {data.machine_name}
                          </MenuItem>
                      ))}
                  </Select>
              </Box>
          </FormControl>
      </Box>
      {/* 오른쪽 영역 - 기존 내부 액션도 원하면 여기에 직접 렌더링 */}
      <Box display="flex" alignItems="center" gap={2}>
          {/* 검색창 */}
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <IconButton onClick={() => setShowSearch((prev) => !prev)}>
                  <SearchIcon />
              </IconButton>
          
              <Collapse in={showSearch} orientation="horizontal">
              <TextField
                  size="small"
                  placeholder="검색"
                  value={globalFilter}
                  onChange={(e) => {
                  setGlobalFilter(e.target.value);
                  table.setGlobalFilter(e.target.value);
                  }}
                  sx={{ minWidth: 200 }}
                  variant="outlined"
                  slots={{
                  input: OutlinedInput,
                  }}
                  slotProps={{
                  input: {
                      endAdornment: (
                      <InputAdornment position="end">
                      <IconButton
                          onClick={() => {
                              setGlobalFilter('');
                              table.setGlobalFilter('');
                              setShowSearch(false); // 닫기
                          }}
                      >
                          <CloseIcon fontSize="small" />
                      </IconButton>
                      </InputAdornment>
                      ),
                  }
                  }}
              />
              </Collapse>
          </Box>
      </Box>  
    </Box>
  );

  // 개선 후 사진 보기
  const showImageStatus = ({ values, row, table }) => {
    //console.log("✅ 편집 호출 완료!", values);
    //console.log("✅ 편집 호출 완료!", row.original);

    // 개선전.후 사진 등록 모달 열기
    if(values.imageStatus !== 'none') {
      openShowImproveImage(values.imageStatus, {...values}); // 개선 전,후 사진 등록 모달 열기
      return;
    }
  };

  ////////////////////////
  // 렌더링
  ////////////////////////

  // StrategyResultStatus 렌더링
  return (
    <TableContainer>
      {/** */}
      <NewTableTemplate 
        // ref={tableRef}
        columns={strategyResultStatusColumns}
        data={tempData || []}
        topToolbarContent={customTableTopToolbar}
        //renderRowActionHeader={customRenderRowActionHeader}
        //renderRowActionContent={customRenderRowActionContent}
        renderRowActionCustomOptions={showImageStatus}
        editDisplayMode={"row"}
        enableCustomGlobalFilter={true}
        enabledSelectionRow={false}
        enabledSelectionAllRow={false}
        templateSX={{
          border: `1px solid ${theme.palette.divider}`,
          borderRadius: "0.375rem", 
          boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.05)',
        }}
      />
      {/* 개선전 사진 확대 모달 */}
      {showImproveImage.state === 'expand_before_image' && 
        <ExpandBeforeImage 
          isOpen={showImproveImage.isOpen}
          imageURL={showImproveImage.rowData.improve_before}
          onConfirm={closeShowImproveImage}
        />
      }
      {/* 개선후 사진 확대 모달 */}
      {showImproveImage.state === 'expand_after_image' && 
        <ExpandAfterImage 
          isOpen={showImproveImage.isOpen}
          imageURL={showImproveImage.rowData.improve_after}
          onConfirm={closeShowImproveImage}
        />
      }
    </TableContainer>
  );
}
// 개선전 사진 확대 모달
const ExpandBeforeImage = ({ isOpen, onConfirm, imageURL }) => {
  return(
    <ModalTemplate 
      isOpen={isOpen}
      handleConfirm={onConfirm}
      handleCancel={onConfirm}
      confirmText="확인"
      title="개선전 사진"
      enableSingleActionButton={true}
      contentSX={{
        margin: "12px 0px",
        // width: '25vw',
        // height: '25vh',
        width: 'auto',
        height: 'auto',
        border: `2px dashed ${COLORS.BORDER_DASH}`,
        borderRadius: 2,
        overflow: 'hidden',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 0,
      }}
    >
      <img 
        src={imageURL || null}
        // src={tempSelectedRowsData.current.improve_before || null}
        alt="Preview"
        style={{
          width: '100%',
          height: '100%',
          //objectFit: 'cover', // 또는 contain
          display: 'block',
          //borderRadius: 'inherit', // Box의 borderRadius 따라감
        }}
      />
    </ModalTemplate >
  );
};
// 개선후 사진 확대 모달
const ExpandAfterImage = ({ isOpen, onConfirm, imageURL }) => {
  return (
    <ModalTemplate 
      isOpen={isOpen}
      handleConfirm={onConfirm}
      handleCancel={onConfirm}
      confirmText="확인"
      title="개선후 사진"
      enableSingleActionButton={true}
      contentSX={{
        margin: "12px 0px",
        // width: '25vw',
        // height: '25vh',
        width: 'auto',
        height: 'auto',
        border: `2px dashed ${COLORS.BORDER_DASH}`,
        borderRadius: 2,
        overflow: 'hidden',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 0,
      }}
    >
      <img 
        src={imageURL || null}
        // src={tempSelectedRowsData.current.improve_after || null}
        alt="Preview"
        style={{
          width: '100%',
          height: '100%',
          //objectFit: 'cover', // 또는 contain
          display: 'block',
          //borderRadius: 'inherit', // Box의 borderRadius 따라감
        }}
      />
    </ModalTemplate>
  );
};